import React, { useState, useEffect, useContext, useRef } from 'react'; /*st48236 - 508 compliance*/
import contactusimg from "../assets/images/Illustrations/Contact.svg";
import { GetPayLoad } from '../services/PayLoadStorage.jsx';
import parse from 'html-react-parser';
import mobile from "../assets/images/icons/Mobile.svg";
import clock from "../assets/images/icons/clock.svg";
import "../assets/css/Style.css";
import { LanguageContext } from "../contexts/LanguageContext";

const Contactus = () => {

    const { pageContent } = useContext(LanguageContext);
    const Payload = GetPayLoad('PayLoad');
    const [contactusContent, setContactusContent] = useState([]);
    const liveContactRef = useRef(null); // Reference for the live region /*st48236 - 508 compliance*/
    const [isContentReady, setContentReady] = useState(false); // st48236 - 508 compliance Track when all API responses are received
    const [apiCallsCompleted, setApiCallsCompleted] = useState(false); // st48236 - 508 compliance Track when all API calls are completed
    const [imageSrc, setImageSrc] = useState([]);

    useEffect(() => {
        if (pageContent?.contactus) {
            setContactusContent(pageContent.contactus);
            setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed 
        }
    }, [pageContent]);

    /*st48236 - 508 compliance*/
    const owningCarrier = Payload?.owning_carrier || '';
    
    useEffect(() => {
        if (owningCarrier) {
            import("../assets/images/Illustrations/Contact-" + owningCarrier + ".svg")
                .then((image) => {
                    setImageSrc(image.default);
                })
                .catch((error) => {
                    // Set a default image if the carrier-specific image is not found
                    setImageSrc(contactusimg); // or use any other default image
                });
        }
    }, [owningCarrier]);
    // Mark content as ready
    useEffect(() => {
        let timeoutId;
        if (apiCallsCompleted) {
          timeoutId = setTimeout(() => {
            setContentReady(true);
            // Bring focus to the <main> tag
           if (liveContactRef.current) {
                liveContactRef.current.focus({preventScroll: true});
            }
        }, process.env.REACT_APP_READABILITY_TIMEOUT); // 5-second delay
        }
        return () => clearTimeout(timeoutId);
      }, [apiCallsCompleted]);
    /*st48236 - 508 compliance*/
    
    return (
        <>
        <main
            role="main"
            tabIndex="-1" // Make the <main> tag focusable
            ref={liveContactRef} // Attach the ref to the <main> tag
            style={{ outline: 'none' }} // revmove border
            aria-label="Contact Us"
        > 
            <div className="conatiner-fluid content-inner mt-n5 py-0">
                <div className="card">
                    <div className="contactus px-3">
                        <div className="mt-5 mb-4 px-4">
                            <div className="col-12 d-xl-flex d-md-flex d-sm-block">
                                <div className={Payload?.owning_carrier === 'J1' ? "col-xl-4 col-md-4 payment text-center text-xl-start text-sm-center text-md-start" :"col-xl-3 col-md-3 payment text-center text-xl-start text-sm-center text-md-start"}>
                                    <img src={imageSrc}
                                        className="width-90"
                                        alt="Contact-us"
                                    />
                                </div>
                                <div tabIndex={0} className={Payload?.owning_carrier === 'J1' ? "col-xl-7 col-md-7 mt-3 ms-5" : "col-xl-8 col-md-8 mt-3 ms-5"}>
                                    <div className="mb-1 contactus-header">
                                        <h4 className="mt-1">{contactusContent?.contactus_inquiry_text}</h4>
                                    </div>
                                    <div className='contactus-content'>
                                        {parse(contactusContent?.contact_table_text ?? '<div className="col-12 mt-4 content-label"><div className="col-12 d-flex"><div className="col-6"><img src="' + mobile + '" alt="Mobile" /><label class=\'mx-2\'><b className="fw-semibold">' + (contactusContent?.contactus_contact_no_text || '') + '  </b> ' + (contactusContent?.contactus_contact_no_value || '') + '</label></div><div className="col-6"><img src="' + clock + '" alt="Time" /><label class=\'mx-2\'><b className="fw-semibold">' + (contactusContent?.contactus_hours_of_operation_text || '') + '</b> ' + (contactusContent?.contactus_hours_of_operation_value || '') + '</label></div></div></div>')}
                                    </div>   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main> {/*st48236 - 508 compliance*/}
        </>
    )
}

export default Contactus;